import BasicService from "./basicService";
import { normalizeError } from "../util/error";
export default class ErrorPageService extends BasicService {
    get props() {
        return this._props;
    }
    show(props) {
        var _a, _b;
        this._props = Object.assign({ hasError: true }, props);
        if (props && props.error) {
            const normalizedError = normalizeError({ error: props.error });
            this._props = Object.assign(Object.assign({}, this.props), { error: normalizedError, message: normalizedError.message, title: normalizedError.title });
            this.notify("show");
            if (("response" in props.error && ((_b = (_a = props.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status) === 500) ||
                "response" in props.error === false)
                throw props.error;
            else
                return;
        }
        this.notify("show");
    }
    hide() {
        this._props = Object.assign(Object.assign({}, this.props), { hasError: false });
        this.notify("hide");
    }
}
export const errorPageService = new ErrorPageService();
//# sourceMappingURL=errorPageService.js.map